import { render, staticRenderFns } from "./iamApplication.vue?vue&type=template&id=1b04bb58&scoped=true&"
import script from "./iamApplication.vue?vue&type=script&lang=js&"
export * from "./iamApplication.vue?vue&type=script&lang=js&"
import style0 from "./iamApplication.vue?vue&type=style&index=0&id=1b04bb58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b04bb58",
  null
  
)

export default component.exports